import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { Subscription } from 'rxjs';
import { SentooService } from '../../../services/sentoo.service';
import { AB_SENTOO_TRANSFER } from '../../../../shared/constants';
import { UserService } from '../../../../shared/services/user.service';
import {
  PaymentStatus,
  StatusResponse,
} from '../../../services/status.service';

@Component({
  selector: 'ab-sentoo',
  templateUrl: './sentoo.component.html',
  styleUrls: ['./sentoo.component.scss'],
})
export class SentooComponent implements OnInit, OnDestroy, OnChanges {
  @Input() rendering: ComponentRendering;
  @ViewChild('qrCodeImage') qrCodeImage: ElementRef;
  @ViewChild('sentooPaymentToken') sentooPaymentToken: TemplateRef<any>;

  public ARUBA_APP_SENTOO_URL = 'arubabank://open/sentoo?';
  public ORCO_APP_SENTOO_URL = 'orcobank://open/sentoo?';

  public paymentStatus: PaymentStatus = 'landing';
  public merchantInfo: Partial<StatusResponse>;
  public isLoading = false;
  public returnUrl: string;

  private subscriptions: Subscription[] = [];
  private encryptedData: string;
  private openAppTimeout;

  constructor(
    private route: ActivatedRoute,
    private sentooService: SentooService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.paymentStatus) {
      console.log(
        'Payment status changed: ',
        changes.paymentStatus.currentValue
      );
    }
  }

  ngOnInit(): void {
    this.paymentStatus = 'landing';
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        const searchParams = new URLSearchParams();
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            searchParams.set(key, params[key]);
          }
        }
        this.encryptedData = searchParams.toString();
        if (this.encryptedData) {
          this.sentooService.setEncryptedData(this.encryptedData);
          this.checkTransferRouteAccess();
        }
      })
    );

    this.openAppSamsungBrowser();
  }

  openAppSamsungBrowser() {
    const url = window.location.href;
    const searchParams = new URL(url).searchParams;
    if (url.indexOf('aruba') !== -1) {
      this.openAppTimeout = setTimeout(() => {
        window.location.replace(this.ARUBA_APP_SENTOO_URL + searchParams.toString());
      }, 1000);
    } else if (url.indexOf('orco') !== -1) {
      this.openAppTimeout = setTimeout(() => {
        window.location.replace(this.ORCO_APP_SENTOO_URL + searchParams.toString());
      }, 1000);
    }
  }

  checkTransferRouteAccess() {
    this.subscriptions.push(
      this.userService
        .userHasAccess(AB_SENTOO_TRANSFER)
        .subscribe((hasAccess) => {
          if (hasAccess) {
            const searchParams = new URLSearchParams(this.encryptedData);
            const sentooTransaction = searchParams?.get('sentoo-transaction');
            const country = searchParams?.get('country');

            this.router.navigate([AB_SENTOO_TRANSFER], {
              queryParams: {
                country,
                'sentoo-transaction': sentooTransaction,
              },
            });
          }
        })
    );
  }

  setReturnUrl(url) {
    this.returnUrl = url;
  }

  setMerchantInfo(merchantInfo) {
    this.merchantInfo = merchantInfo;
  }

  setPaymentStatus(paymentStatus: PaymentStatus) {
    this.paymentStatus = paymentStatus;
  }

  resetPayment() {
    this.paymentStatus = 'landing';
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    if (this.openAppTimeout) {
      clearTimeout(this.openAppTimeout);
    }
  }
}
